function parseJsonPointer(pointer) {
  return pointer.split("/").filter((segment, index) => (index !== 0 || segment !== "#") && segment);
}
function getValueByPath(obj, pointer) {
  return pointer.reduce((acc, part) => {
    if (acc === void 0 || acc === null) {
      return void 0;
    }
    return acc[part];
  }, obj);
}
export {
  getValueByPath,
  parseJsonPointer
};
//# sourceMappingURL=json-path-utils.js.map
